export const getRandomInt = () => (Math.floor(Math.random() * (Number.MAX_SAFE_INTEGER - 1)) + 1);
